import reducer, { actions } from './slice';
import * as asyncActions from './asyncActions';
import * as selectors from './selectors';

export const articleStore = {
  actions,
  asyncActions,
  selectors,
};

export default reducer;
